@if (this.isButton() && !this.readOnly()) {
  <cam-button class="space-between align-center g-space-sm" [type]="this.type()" [icon]="this.iconName()">
    <div class="pr-space-md label">
      {{ this.label() | translate }}
    </div>
    <div>
      <cam-font-icon type="xs" name="arrow-big-bottom"></cam-font-icon>
    </div>
  </cam-button>
} @else {
  <cam-badge [value]="this.label() | translate" [type]="this.type()"></cam-badge>
}
